'use client';

import type { ImageGalleryFragment } from '@packages/gql/generated/shopping/graphql';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { useIntl } from 'react-intl';
import { Cliplister } from '../../Cliplister/Cliplister.client';
import { ImageGalleryColorDialog } from '../ImageGalleryColorDialog/ImageGalleryColorDialog.client';
import { useIsDialogOpen } from '../ImageGalleryProvider/ImageGalleryProvider.client';

type ImageGalleryActionButtonsProps = {
  product: ImageGalleryFragment;
  withColorDialog?: boolean;
};

export const ImageGalleryActionButtons = ({
  product,
  withColorDialog,
}: ImageGalleryActionButtonsProps) => {
  const { formatMessage } = useIntl();
  const [, setIsDialogOpen] = useIsDialogOpen();

  return (
    <div className="absolute right-0 bottom-0 mr-1.5 mb-1.5 flex flex-col gap-1">
      <Cliplister data={product} />
      <Button
        onClick={() => setIsDialogOpen(true)}
        className="bg-color-text-light h-5 w-5 touch-manipulation rounded-full border-none p-0 shadow-md"
        aria-label={formatMessage({
          id: 'imageGallery.aria.zoom',
          defaultMessage: 'Vollbildzoom öffnen',
        })}
      >
        <span className="icon-emp-enlarge size-4" />
      </Button>
      {withColorDialog && <ImageGalleryColorDialog data={product} />}
    </div>
  );
};
